export const valueContains = (value, filter) =>
  value.toLowerCase().includes(filter.toLowerCase());
